import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class CarouselItemsViewedApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.CarouselItemsViewed;

  constructor(
    private item?: any,
    private index?: number,
    private categoryName?: string,
    private label?: string,
  ) {
  }

  getPayload(): any {
    return {
      item: this.item,
      index: this.index,
      categoryName: this.categoryName,
      label: this.label
    };
  }
}
